import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { TableColumn } from 'src/app/models/TableColumn';


import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
    selector: 'app-list-partner-staff',
    templateUrl: './list-partner-staff.component.html',
    styleUrl: './list-partner-staff.component.css',
    imports: [
        CommonModule,
        FormsModule,
        TableControlComponent,
        TooltipDirective
    ]
})
export class ListPartnerStaffComponent {
  @Input() customerDataInput: any;
  @Input() readOnly = false;
  partnerStaffList: UserDTO[] = [];
  filteredCustomers: any[] = [];
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans',
    'numberDevices',
  ];
  isFilteredByStatus: boolean = false;
  originalPartnerStaffList: any[] = [];
  selectedCustomer: UserDTO = {} as UserDTO;
  idModule: number = 4;
  alert: Alert = {} as Alert;
  userRequestDTO: UserRequestDTO = {
    userId: undefined,
  };


  columns: TableColumn[] = [
    { key: 'userId', header: 'User Account' },
    { key: 'userNames', header: 'Name', width: 250 },
    { key: 'userMail', header: 'Email', width: 250 },
    { key: 'userPhone', header: 'Contact Number' },
    { key: 'userStatus', header: 'Status', width: 250 },


  ];

  actionButtons = [
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil' },
    { label: 'archive', class: 'danger', icon: 'bi bi-archive' },

  ];

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public paginationService: PaginationService
  ) { }

  ngOnInit() {


    this.loadPartnerStaff();
  }


  loadPartnerStaff() {
    this.userRequestDTO.userId = this.customerDataInput.userId ? this.customerDataInput.userId : this.customerDataInput;
    this.customerService.getListUsersOfStaff(this.userRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );

  }

  onAction(event: { action: string; item: UserDTO }): void {

    switch (event.action) {

      case 'edit':
        this.navigateToUpdateUser(event.item)
        break;
      case 'archive':
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modalArchive')).show()


        this.setArchivedCustomer(event.item)
        break;
    }
  }


  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListCustomers(partnerStaffList: UserDTO[]) {
    // Guarda la lista de clientes original
    this.partnerStaffList = partnerStaffList;
    this.originalPartnerStaffList = this.partnerStaffList.slice();
    this.partnerStaffList = this.originalPartnerStaffList.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
  }





  setSelectedCustomer(customer: any) {
    this.selectedCustomer = customer;
  }

  setArchivedCustomer(customer: any) {
    this.selectedCustomer = customer;
    this.selectedCustomer.userStatus = 2;
  }

  // toggleStatus(event: any, customer: any) {
  //   customer.userStatus = event.target.checked ? 1 : 0;
  //   const indice = this.originalCustomers.findIndex(
  //     (cust) => cust.userId === customer.userId
  //   );
  //   if (indice !== -1) {
  //     this.originalCustomers[indice].userStatus = customer.userStatus;
  //   }
  // }

  openConfirmationModal(customer: any) {
    this.selectedCustomer = customer;
  }

  updateUserStatus(confirmed: boolean) {
    if (confirmed) {
      this.customerService
        .updateCustomerStatus(this.selectedCustomer)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateCustomerStatus(Data);
            } else {
              this.HandleUpdateCustomerStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      this.loadPartnerStaff();
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Customer status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToUpdateUser(customer: any) {
    this.router.navigate(['/partners/update-partner-staff'], {
      relativeTo: this.route,
      state: { customerData: customer },
    });
  }

  navigateToCustomerUsers() {
    const user: UserDTO = {} as UserDTO;
    this.router.navigate(['/partners/partner-staff'], {
      relativeTo: this.route,
      state: { customerData: user },
    });
  }

  goBack() {
    window.location.href = '/home';
  }


}
